var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showUpdateAvailableTag || _vm.showUpdateSoonTag || _vm.showNewTag)?_c('span',{staticClass:"update-tag py-2 rounded-lg rounded-l-0",class:`px-${_vm.large ? 8 : 4} mt-1 ml-n1`},[_vm._v(_vm._s(_vm.updateText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }